export default {
    state: {
        casas: [],
    },
    getters: {
        casas: (state) => state.casas
    },
    mutations: {
        SET_CASAS: (state, payload) => state.casas = payload 
    },
    actions: {
        fetch({commit}, payload) {
          this.dispatch('index', payload)
            .then((response) => {
              commit('SET_CASAS', response.datos)
            })
        },
    }
}